(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6837],{

/***/ 71563:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/forget-password",
      function () {
        return __webpack_require__(97203);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 10067:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function AlertMessage(param) {
    var type = param.type, text = param.text;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true), visible = ref[0], setVisible = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var timer = setTimeout(function() {
            setVisible(false);
        }, 5000);
        return function() {
            return clearTimeout(timer);
        };
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: visible && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
            className: "alert-message ".concat(type),
            children: text
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (AlertMessage);


/***/ }),

/***/ 76931:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36968);


function Loader() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        style: {
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: "#ffffffab",
            zIndex: 9998
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            style: {
                position: "fixed",
                top: "45%",
                left: "50%",
                textAlign: "center",
                zIndex: 9999
            },
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                animation: "border",
                role: "status",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "visually-hidden",
                    children: "Loading..."
                })
            })
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (Loader);


/***/ }),

/***/ 57282:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B1": function() { return /* binding */ EMAIL_VALIDATOR; },
/* harmony export */   "oq": function() { return /* binding */ DOCUMENT_EXTENSIONS; }
/* harmony export */ });
/* unused harmony export IMAGE_EXTENSIONS */
var EMAIL_VALIDATOR = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
var DOCUMENT_EXTENSIONS = ".pdf,.csv,.doc,.docx,.xlsx,.txt,.jpg,.jpeg,.png,.heic";
var IMAGE_EXTENSIONS = ".jpg,.jpeg,.png";


/***/ }),

/***/ 53567:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Q": function() { return /* reexport */ authGuard; },
  "k": function() { return /* reexport */ unAuthGuard; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/helpers/hoc/unAuthGuard.tsx


function withOutAuth(WrapperComponent) {
    return function(props) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(WrapperComponent, (0,_object_spread/* default */.Z)({}, props));
    };
}
/* harmony default export */ var unAuthGuard = (withOutAuth);

;// CONCATENATED MODULE: ./src/helpers/hoc/authGuard.tsx


function withAuth(WrapperComponent) {
    return function(props) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(WrapperComponent, (0,_object_spread/* default */.Z)({}, props));
    };
}
/* harmony default export */ var authGuard = (withAuth);

;// CONCATENATED MODULE: ./src/helpers/hoc/index.ts




/***/ }),

/***/ 2324:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ useFormBackground; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

function useFormBackground() {
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        document.body.classList.add("form_background");
        return function() {
            document.body.classList.remove("form_background");
        };
    }, []);
}


/***/ }),

/***/ 97203:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_throw_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(51351);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(10682);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(21608);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(31555);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(74119);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(4266);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(35005);
/* harmony import */ var src_components_Icons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32909);
/* harmony import */ var src_config_validators__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(57282);
/* harmony import */ var src_components_Loader__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(76931);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var src_requests_auth__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(19795);
/* harmony import */ var src_components_AlertMessage__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(10067);
/* harmony import */ var src_helpers_hooks_auth__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(2324);
/* harmony import */ var src_helpers_hoc__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(53567);
/* harmony import */ var src_components_Metadata__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(49499);
















function ForgetPassword(param) {
    var param = param !== null ? param : (0,_swc_helpers_src_throw_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(new TypeError("Cannot destructure undefined"));
    (0,src_helpers_hooks_auth__WEBPACK_IMPORTED_MODULE_8__/* .useFormBackground */ .b)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(""), email = ref[0], setEmail = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), mailSent = ref1[0], setMailSent = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(), alert = ref2[0], setAlert = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), working = ref3[0], setWorking = ref3[1];
    var onReset = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(e) {
            var ref, ref1, ref2;
            return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        e.preventDefault();
                        if (src_config_validators__WEBPACK_IMPORTED_MODULE_13__/* .EMAIL_VALIDATOR.test */ .B1.test(email)) {
                            _ctx.next = 3;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 3:
                        _ctx.prev = 3;
                        setWorking(true);
                        _ctx.next = 7;
                        return (0,src_requests_auth__WEBPACK_IMPORTED_MODULE_6__/* .resetPassword */ .c0)(email);
                    case 7:
                        setMailSent(true);
                        setWorking(false);
                        _ctx.next = 17;
                        break;
                    case 11:
                        _ctx.prev = 11;
                        _ctx.t0 = _ctx["catch"](3);
                        ;
                        setWorking(false);
                        console.log((_ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : (ref = _ctx.t0.response) === null || ref === void 0 ? void 0 : ref.data) || (_ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : _ctx.t0.message));
                        setAlert({
                            text: (_ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : (ref1 = _ctx.t0.response) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.data) === null || ref2 === void 0 ? void 0 : ref2.message) || (_ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : _ctx.t0.message) || "Something went wrong",
                            type: "error"
                        });
                    case 17:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    3,
                    11
                ]
            ]);
        }));
        return function onReset(e) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
        className: "forgetPassword",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_components_Metadata__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                title: "Reset User Password"
            }),
            working && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_components_Loader__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {}),
            alert && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_components_AlertMessage__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)({}, alert)),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                            className: "form_login color_bg-white color_border-gray--08",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                    className: "d-flex justify-content-center margin_bottom-24",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_components_Icons__WEBPACK_IMPORTED_MODULE_3__/* .LogoBig */ .$T, {})
                                }),
                                !mailSent ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("form", {
                                    onSubmit: onReset,
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                            className: "text-center para-5 fw-400 color_text-gray--01",
                                            style: {
                                                margin: "24px 0"
                                            },
                                            children: "Enter your email to reset password"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                            controlId: "floatingInput",
                                            label: "Email Address",
                                            className: "mb-3",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_19__/* ["default"].Control */ .Z.Control, {
                                                type: "email",
                                                placeholder: "Email Address",
                                                className: "form_input",
                                                value: email,
                                                onChange: function(param) {
                                                    var target = param.target;
                                                    return setEmail(target.value);
                                                },
                                                required: true
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                                            variant: "primary",
                                            type: "submit",
                                            className: "form_btn para-5 fw-300 w-100",
                                            disabled: !src_config_validators__WEBPACK_IMPORTED_MODULE_13__/* .EMAIL_VALIDATOR.test */ .B1.test(email),
                                            children: "Reset Password"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                            className: "text-center",
                                            style: {
                                                marginTop: "1em"
                                            },
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_5___default()), {
                                                href: "/login",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                                                    className: "para-5 fw-300 color_text-primary link_hover link_underline-none",
                                                    children: "Cancel"
                                                })
                                            })
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("p", {
                                            style: {
                                                marginTop: "1em"
                                            },
                                            children: [
                                                "if an account exists for ",
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                                    className: "fw-400 color_text-gray--01",
                                                    children: email
                                                }),
                                                ", you will get an email with instructions on resetting your password. If it doesn't arrive, be sure to check your spam folder"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                            className: "fw-400 color_text-gray--01 text-center",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_5___default()), {
                                                href: "/login",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                                                    className: "form_btn-no-outline w-100",
                                                    children: "Back to Login"
                                                })
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["default"] = ((0,src_helpers_hoc__WEBPACK_IMPORTED_MODULE_9__/* .withOutAuth */ .k)(ForgetPassword));


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5231,89,5799,9774,2888,179], function() { return __webpack_exec__(71563); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);